export const incidentEvents = [
  {
    id: "IE001",
    learnerId: "L002",
    eventType: "Phishing Click",
    simulationName: "Urgent: Password Expiry",
    simulationId: "PS001",
    timestamp: "2023-10-15T09:24:00Z",
    result: "Clicked Link",
    followUpAction: "Assigned Remedial Training",
  },
  {
    id: "IE002",
    learnerId: "L004",
    eventType: "Credential Submission",
    simulationName: "Urgent: Password Expiry",
    simulationId: "PS001",
    timestamp: "2023-10-15T10:05:00Z",
    result: "Submitted Credentials",
    followUpAction: "Manager Notified + Remedial Training",
  },
  {
    id: "IE003",
    learnerId: "L008",
    eventType: "Phishing Click",
    simulationName: "Urgent: Password Expiry",
    simulationId: "PS001",
    timestamp: "2023-10-15T11:42:00Z",
    result: "Clicked Link",
    followUpAction: "Assigned Remedial Training",
  },
  {
    id: "IE004",
    learnerId: "L002",
    eventType: "Phishing Click",
    simulationName: "IT: Mandatory Software Update",
    simulationId: "PS003",
    timestamp: "2023-11-20T14:10:00Z",
    result: "Clicked Link",
    followUpAction: "Assigned Remedial Training",
  },
  {
    id: "IE005",
    learnerId: "L004",
    eventType: "Credential Submission",
    simulationName: "IT: Mandatory Software Update",
    simulationId: "PS003",
    timestamp: "2023-11-20T14:33:00Z",
    result: "Submitted Credentials",
    followUpAction: "Manager Notified + Remedial Training",
  },
  {
    id: "IE006",
    learnerId: "L005",
    eventType: "Phishing Click",
    simulationName: "Q3 Benefits Update",
    simulationId: "PS002",
    timestamp: "2023-11-02T08:55:00Z",
    result: "Clicked Link",
    followUpAction: "Awareness Email Sent",
  },
  {
    id: "IE007",
    learnerId: "L001",
    eventType: "Phishing Report",
    simulationName: "Q3 Benefits Update",
    simulationId: "PS002",
    timestamp: "2023-11-02T09:02:00Z",
    result: "Correctly Reported",
    followUpAction: "Positive Reinforcement Sent",
  },
  {
    id: "IE008",
    learnerId: "L003",
    eventType: "Phishing Report",
    simulationName: "IT: Mandatory Software Update",
    simulationId: "PS003",
    timestamp: "2023-11-20T13:58:00Z",
    result: "Correctly Reported",
    followUpAction: "Positive Reinforcement Sent",
  },
  {
    id: "IE009",
    learnerId: "L006",
    eventType: "Phishing Report",
    simulationName: "Urgent: Password Expiry",
    simulationId: "PS001",
    timestamp: "2023-10-15T09:45:00Z",
    result: "Correctly Reported",
    followUpAction: "Positive Reinforcement Sent",
  },
  {
    id: "IE010",
    learnerId: "L007",
    eventType: "Training Not Started",
    simulationName: null,
    simulationId: null,
    timestamp: "2024-01-17T00:00:00Z",
    result: "Overdue",
    followUpAction: "Automated Reminder Sent",
  },
];